<template>
    <div :style="[wrapperOverride]" v-if="selectedOption" :class="['wrapper', borderless && 'borderless']">
        <div
            :class="{ active: flyoutVisible, pill: !borderless }"
            class="select-button"
            ref="exclude-button"
            @click="toggleFlyout"
        >
            <span class="label">{{ label }}</span> <span class="option-selected">{{ selectedOption.name }}</span>
            <i class="fas fa-angle-down"></i>
        </div>

        <ul
            :style="[flyoutOverride]"
            class="flyout options"
            :class="[alignLeft ? 'left' : 'right', { active: flyoutVisible }]"
            v-closable="{
                exclude: ['exclude-button'],
                handler: 'close',
            }"
        >
            <li
                v-for="option in options"
                :key="option"
                :class="{ active: selectedOption == option }"
                @click="selectOption(option)"
            >
                {{ option.name }}
            </li>
        </ul>
    </div>
</template>

<script>
// lodash components
import find from 'lodash/find'
import some from 'lodash/some'
import split from 'lodash/split'
import toNumber from 'lodash/toNumber'

export default {
    data() {
        return {
            flyoutVisible: false,
            wrapperOverride: {},
            flyoutOverride: {},
            iframeAllowedSites: [],
        }
    },

    props: {
        label: {
            default: null,
        },
        options: {
            default: [],
        },
        borderless: {
            default: false,
        },
        alignLeft: {
            default: false,
        },
    },

    computed: {
        selectedOption: function () {
            const activeOption = find(this.options, function (option) {
                return option.active
            })

            return activeOption || null
        },
    },

    mounted() {
        if (window.IS_IFRAME && window.innerWidth < 995) {
            this.flyoutOverride.display = 'none'
        }

        this.iframeAllowedSites = JSON.parse(this.themeSetting('iframe_allowed_sites'))

        window.addEventListener(
            'message',
            event => {
                const messageContent = event.data
                if (some(this.iframeAllowedSites, ['name', event.origin])) {
                    if (window.innerWidth < 995) {
                        const variables = split(messageContent, '|')
                        const modalOffset = variables[1]
                        const windowHeight = variables[2]
                        const iframeOffsetBottom = variables[3]
                        const scrollBottom = variables[4]

                        const screenBottom = toNumber(modalOffset) + toNumber(windowHeight) - 330

                        this.wrapperOverride.position = 'initial'

                        if (toNumber(iframeOffsetBottom) > toNumber(scrollBottom) + 100 && this.flyoutVisible) {
                            this.flyoutOverride.height = '290px'
                            this.flyoutOverride.position = 'fixed'
                            this.flyoutOverride.width = '100%'
                            this.flyoutOverride.top = screenBottom + 'px'
                        }
                    } else {
                        this.wrapperOverride = {}
                        this.flyoutOverride = {}
                    }
                }
            },
            false,
        )
    },

    methods: {
        close: function () {
            this.flyoutVisible = false
        },
        open: function () {
            this.flyoutVisible = true
        },
        toggleFlyout: function () {
            this.flyoutVisible = !this.flyoutVisible

            if (window.IS_IFRAME && window.innerWidth < 995) {
                this.flyoutOverride.display = this.flyoutVisible ? 'block' : 'none'
            }
        },
        selectOption: function (option) {
            this.selectedOption.active = false
            option.active = true

            this.trackEvent('event', {
                eventCategory: 'sort-type',
                eventAction: 'click',
                eventLabel: option.field === false ? 'eligibility' : option.field,
            })

            this.close()
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/variables';
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.wrapper {
    position: relative;
    margin-left: auto;

    @media screen and (max-width: $bp-large) {
        margin-right: auto;
    }

    .select-button {
        .option-selected {
            font-weight: bold;
            color: $text-dark;
        }

        .fa-angle-down {
            margin-left: 5px;
            font-weight: normal;
        }
    }

    .options {
        list-style-type: none;
        font-size: rem(16px);

        @media screen and (max-width: $bp-large) {
            position: fixed;
            top: initial;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            transform: translate(0, 100%);
            border-left: 0;
            border-right: 0;
            border-bottom: 0;
            border-radius: 8px 8px 0 0;

            &.active {
                transform: translate(0, 0);
            }
        }

        li {
            font-weight: bold;
            color: $color-black;
            margin: 0;
            padding: 13px 32px;
            cursor: pointer;
            transition: background 0.2s;
            white-space: nowrap;

            &:hover {
                background: $color-grey-ultralight;
            }

            &.active {
                color: $color-grey-dark;
            }
        }
    }
}

.borderless {
    margin-left: 0;
    font-size: rem(14px);

    .select-button {
        position: relative;
        cursor: pointer;
        user-select: none;
    }

    .options {
        padding: 0;
        top: 30px;
    }
}
</style>
